import { Directive, ElementRef, OnChanges, AfterViewChecked, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appScrollToBottom]'
})
export class ScrollToBottomDirective implements OnChanges, AfterViewChecked {
  @Input() messages: any[] = [];
  private isNearBottom = true;

  constructor(private el: ElementRef) { }

  ngAfterViewChecked() {
    if (this.isNearBottom) {
      this.scrollToBottom();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.messages) {
      // Check if the user was already at the bottom before new messages
      this.checkIfUserWasAtBottom();
      // Schedule a scroll to bottom if needed
      setTimeout(() => {
        if (this.isNearBottom) {
          this.scrollToBottom();
        }
      }, 100);
    }
  }

  private checkIfUserWasAtBottom() {
    const element = this.el.nativeElement;
    // Consider "near bottom" if within 100px of the bottom
    const atBottom = element.scrollHeight - element.scrollTop - element.clientHeight < 100;
    this.isNearBottom = atBottom;
  }

  private scrollToBottom() {
    try {
      this.el.nativeElement.scrollTop = this.el.nativeElement.scrollHeight;
    } catch (err) { }
  }
}
